import React from "react"

export const GoogleIcon = () => {
  return (
    <svg
      width='26,75'
      height='25,89'
      viewBox='0 0 31 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_202_633)'>
        <path
          d='M6.75259 0.479782C5.54206 -0.168932 4.12076 -0.153933 2.91797 0.489156L17.015 13.0978L21.7507 8.5062L6.75259 0.479782Z'
          fill='currentColor'
        />
        <path
          d='M1.50825 1.7793C1.16404 2.32489 0.966797 2.94923 0.966797 3.61107V26.3835C0.966797 27.0247 1.14664 27.636 1.4715 28.1703L15.6478 14.4255L1.50825 1.7793Z'
          fill='currentColor'
        />
        <path
          d='M28.0308 11.866L23.5136 9.44922L18.4375 14.3689L24.6584 19.9318L28.0328 18.1262C29.2471 17.4738 29.9742 16.3038 29.9742 14.9952C29.9723 13.6865 29.2471 12.5165 28.0308 11.866Z'
          fill='currentColor'
        />
        <path
          d='M17.0704 15.6963L2.85547 29.4786C3.47233 29.8199 4.14915 29.9999 4.82982 29.9999C5.4873 29.9999 6.14864 29.8386 6.7539 29.5143L22.8756 20.8879L17.0704 15.6963Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_202_633'>
          <rect width='30.9417' height='30' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
